import React from "react";
import "bootstrap/dist/css/bootstrap.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebook } from "@fortawesome/free-brands-svg-icons";
import { faInstagram } from "@fortawesome/free-brands-svg-icons";
import { faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faYoutube } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import doyen1images from "../images/doyen1images.png";

const NewFooter: React.FC = () => {
  const navigate = useNavigate();

  const toFacebooksite = () => {
    window.open(
      "https://web.facebook.com/profile.php?id=100091606221617",
      "_blank",
    );
  };
  const toDoyenifysite = () => {
    window.open("http://doyenify.com/", "_blank");
  };
  const toLinkedinsite = () => {
    window.open("https://www.linkedin.com/company/doyenify/", "_blank");
  };

  const toTwittersite = () => {
    window.open("https://twitter.com/DOYENIFY", "_blank");
  };
  const toInstagramsite = () => {
    window.open("https://www.instagram.com/doyenify/", "_blank");
  };

  const goTermsandconditions = () => {
    navigate("/termsandconditions");
  };

  const goPrivacypolicy = () => {
    navigate("/privacypolicy");
  };

  const goRefundPolicy = () => {
    navigate("/refundpolicy");
  };
  const toYoutubesite = () => {
    window.open("https://www.youtube.com/@DOYENIFY", "_blank");
  };
  const toGmailsite = () => {
    window.open(
      "https://mail.google.com/mail/?view=cm&fs=1&tf=1&to=info.doyenify@gmail.com",
      "_blank",
    );
  };

  return (
    <>
      <div
        className="footer text-center"
        style={{ overflowX: "hidden", height: "100%" }}
      >
        <br />
        <br />
        <br />
        <h3 style={{ fontSize: "35px", marginBottom: "12px" }}>
          Doyenify Academy
        </h3>

        <div
          style={{ fontSize: "22px", fontWeight: "400", marginBottom: "12px" }}
        >
          "You don't have to be great to start, but you have to start to be
          great." Zig Ziglar
        </div>
        <div
          style={{
            fontSize: "35px",
            marginBottom: "12px",
            justifyContent: "center",
            display: "flex",
          }}
        >
          {/* <div className="col-3"></div> */}
          <div className="col-6">
            <span className="socialmed" onClick={toFacebooksite}>
              <FontAwesomeIcon
                className="socialmed2"
                icon={faFacebook}
                style={{ marginRight: "30px", textDecoration: "none" }}
              />
            </span>
            <span className="socialmed" onClick={toLinkedinsite}>
              <FontAwesomeIcon
                className="socialmed2"
                icon={faLinkedin}
                style={{ marginRight: "30px", textDecoration: "none" }}
              />
            </span>
            <span className="socialmed" onClick={toTwittersite}>
              <FontAwesomeIcon
                className="socialmed2"
                icon={faTwitter}
                style={{ marginRight: "30px", textDecoration: "none" }}
              />
            </span>
            <span className="socialmed" onClick={toInstagramsite}>
              <FontAwesomeIcon
                className="socialmed2"
                icon={faInstagram}
                style={{ marginRight: "30px", textDecoration: "none" }}
              />
            </span>
            <span className="socialmed" onClick={toYoutubesite}>
              <FontAwesomeIcon
                className="socialmed2"
                icon={faYoutube}
                style={{ marginRight: "30px", textDecoration: "none" }}
              />
            </span>
            <span className="socialmed" onClick={toGmailsite}>
              <FontAwesomeIcon
                className="socialmed2"
                style={{ textDecoration: "none" }}
                icon={faEnvelope}
              />
            </span>
          </div>
          {/* <div className="col-3"></div> */}
        </div>
        <div
          className="flex justify-center items-center"
          style={{ fontSize: "35px", fontWeight: "400" }}
        >
          Powered by:
          <span className="Naming" onClick={toDoyenifysite}>
            {" "}
            <img
              style={{ marginLeft: "7px", height: "40px", cursor: "pointer" }}
              alt=""
              src={doyen1images}
            />
          </span>
        </div>
        <br />
        <br />
        <br />

        <div className="text-center">
          <span style={{ fontWeight: "502" }}>
            © {new Date().getFullYear()}. All Right Reserved. |{" "}
            <span className="termsandcondition" onClick={goTermsandconditions}>
              Terms and conditions
            </span>{" "}
            |{" "}
            <span className="termsandcondition" onClick={goPrivacypolicy}>
              Privacy Policy
            </span>{" "}
            |{" "}
            <span className="termsandcondition" onClick={goRefundPolicy}>
              Refund Policy
            </span>
          </span>
        </div>
      </div>
    </>
  );
};

export default NewFooter;
